export default __webpack_public_path__ + "assets/images/b39f7afe635ee374bde3c82a5823e2c9.png";